import React, { useEffect, useState, useMemo } from 'react'
import { RadioButton } from './'
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv'
import BlueButton from '../BlueButton'

const OneChoice = ({data={}}) => {

  const {doc, setDoc, answerOptions} = data

  const question = useMemo(() => ({ questionId: data?._id }), [data]);

  const [userResponse, setUserResponse] = useState()

  const testFunction = () => {
    process.env.NODE_ENV === "development" && console.log("doc", doc, "userResponse", userResponse, "question", question, question?.title)
    
  }

  useEffect(()=>{
    const initialUserResponse = doc?.userResponses?.find((item)=>item?.questionId === question?.questionId)
    //process.env.NODE_ENV === "development" && console.log("initialUserResponse", initialUserResponse)
    setUserResponse(initialUserResponse)
  }, [doc, question])

  const dataToAllComponents = {userResponse, setUserResponse, doc, setDoc, question}

  return (
    <div className='answer-container'>
    <BlueButton fn={testFunction} hide={true} text={"Test One Choice"} />
   {/*  <h3 className='margin-bottom'>{question?.title} {question?.required && "*"}</h3> */}
    <VisDiv rules={[answerOptions, answerOptions?.length > 0]} >
        {answerOptions?.map((item, index)=> {
          if(!item) return null
          return ( 
            <div key={item?.answerId ? item?.answerId : index} >
              <RadioButton data={{...dataToAllComponents, ...item}} > {item?.answerText} </RadioButton>
            </div>
        )})}
      </VisDiv>
    </div>
  )
}

export default OneChoice
